<template>
  <div class="ProjectView" v-if="p && p.uuid">
    <help-message>
      <h3 slot="title">Page des images d'un projet</h3>
      <p>
        Cette page permet de rapidement assigner leur auteur(s) aux images
        présentes dans un projet.
      </p>
    </help-message>
    <div class="columns">
      <div class="column is-full">
        <h1 class="title">Crédits et gestion d'images</h1>
        <h2 class="subtitle">{{ p.code }} : {{ p.name }}&nbsp;</h2>
        <p>
          <router-link class="button" :to="`/projects/view/${p.uuid}`"
            ><i class="fa fa-eye"></i>&nbsp;vue du projet</router-link
          >&nbsp;
          <router-link class="button" :to="`/project/edit/${p.uuid}`"
            ><i class="fa fa-edit"></i> éditer </router-link
          >&nbsp;
          <a
            class="button"
            :href="
              `${$options.defaultApiUrl}print/project/${p.uuid}?token=${
                $store.state.user.token
              }`
            "
            ><i class="fa fa-print"></i>&nbsp;imprimer</a
          >&nbsp;
          <router-link class="button" :to="`/projects/view/${p.uuid}/contacts`"
            ><i class="fa fa-file"></i>&nbsp;fiche contact</router-link
          >
        </p>
      </div>
    </div>
    <violet-bar>Images</violet-bar>
    <div class="columns">
      <div class="column is-two-thirds">
        <div class="squarebox">
          <div class="columns is-multiline">
            <div class="column is-one-fifth" :key="id" v-for="id in deduplicated_ids">
              <div class="squarebox" style="position:relative;cursor:pointer;" @click="selected[id] = !selected[id]">
                <ratio-cropper :picture-id="id" :ratio="1" :with_authors="true" :update="should_update"/>
                <input
                  type="checkbox"
                  style="position:absolute;z-index: 1;top: 0;left: 0;"
                  v-model="selected[id]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-one-third">
        <div class="squarebox" v-show="selected_array.length">
          <h3>Assigner des auteurs à ces images</h3>
          <hr>
          <partner-suggestor :item="null" :full_contact="true" @update="takeContact"></partner-suggestor>
          <div v-if="pendingAuthors.length">
            <div class="tags">
              <div class="tag" v-for="contact in pendingAuthors" :key="contact.id"
                   @click="removeContact(contact)">{{ contact.name }}
                <span class="delete is-small"></span></div>
            </div>
            <hr>
            <div class="buttons">
              <button class="button is-white" @click="setContacts">Définir ces contacts pour ces images</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/projects";
import { formatNumbers } from "../../util/func";
import ApiPicture from "../../components/Form/ApiPicture";
import HelpMessage from "../../components/Form/HelpMessage";
import { defaultApiUrl } from "../../api";
import VioletBar from "./VioletBar";
import BoundApiPicture from "../Export/Fiche/Index/Image/BoundApiPictureIndex";
import RatioCropper from "../../components/Layout/ApiPictureCropped";
import KvSuggestorMultiple from "../../components/Form/KvSuggestorMultiple";
import {actions, types} from "../../store/actions/pictures";
import PartnerSuggestor from "../../components/Form/PartnerSuggestor";

export default {
  name: "ProjectPictures",
  components: {
    PartnerSuggestor,
    RatioCropper,
    VioletBar,
    HelpMessage
  },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  computed: {
    selected_array() {
      return Object.keys(this.selected).reduce((out, id) => this.selected[id] ? out.concat([id]) : out, []);
    },
    deduplicated_ids() {
      return this.p.pictures_ids.reduce((acc, r) => {
        if (acc.indexOf(r) === -1) {
          acc.push(r)
        }
        return acc;
      }, []);
    },
  },
  methods: {
    takeContact(contact) {
      if (!this.pendingAuthors.find(a => a.id === contact.id)) {
        this.pendingAuthors.push(contact);
      }
    },
    removeContact(contact) {
      this.pendingAuthors = this.pendingAuthors.filter(a => a.id !== contact.id);
    },
    async setContacts() {
      await this.$store.dispatch(types.BULK_SET_AUTHORS, {pictures: this.selected_array.map(a => ({id: a})), authors: this.pendingAuthors});
      await this.fetch();
      this.should_update = !this.should_update;
      this.pendingAuthors = [];
    },
    async fetch() {
      this.p = await this.$store.dispatch(t.GET_PROJECT_BY_UUID_D, {
        uuid: this.uuid
      });
      this.selected = this.p.pictures_ids.reduce((b, a) => {
        b[a] = false;
        return b;
      }, {});
    }
  },
  defaultApiUrl,
  data() {
    return {
      p: {},
      selected: {},
      loading: false,
      pendingAuthors: [],
      should_update: false
    };
  },
  async mounted() {
    await this.fetch();
  }
};
</script>

<style lang="scss">
.ProjectPictures {
}
</style>
